import React from "react";
import Grid from "@mui/material/Grid2";
import { Typography, Card, CardContent, CardMedia, Box } from "@mui/material";
import { AnswerDetails } from "../../types/HelpAndSupportDataTypes";

interface ContentSectionProps {
  title: string;
  data: {
    question: string;
    answer: string | AnswerDetails[];
    image: string;
    note?: string;
  }[];
}

const ContentSection: React.FC<ContentSectionProps> = ({ title, data }) => {
  const renderAnswer = (answer: string | AnswerDetails[]): React.ReactNode => {
    if (typeof answer === "string") {
      return answer;
    }
    return (
      <div style={{ padding: 0, fontSize: "12px" }}>
        {answer.map((data, index) => (
          <div key={index} style={{ marginBottom: "8px" }}>
            <Typography
              variant="body2"
              sx={{ marginBottom: "4px", fontSize: "12px" }}
            >
              {data.category}
            </Typography>
            <div>
              {data.details.map((detailsAnswer, idx) => (
                <div
                  key={idx}
                  style={{
                    marginBottom:
                      idx === data.details.length - 1 &&
                      index !== answer.length - 1
                        ? "20px"
                        : "4px",
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{ marginBottom: "4px", fontSize: "12px" }}
                  >
                    {detailsAnswer}
                  </Typography>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    );
  };

  return (
    <Box>
      <Typography
        variant="h4"
        sx={{
          marginBottom: "20px",
          fontWeight: "600",
          fontSize: { md: "24px", xs: "14px" },
        }}
      >
        {title}
      </Typography>
      <Grid container spacing={3}>
        {data.map((item, index) => (
          <Grid size={{ xs: 12, sm: 6, md: 4 }} key={index}>
            <Card
              elevation={0}
              sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "left",
                textAlign: "center",
                borderRadius: "0",
              }}
            >
              <CardMedia
                component="img"
                image={item.image}
                alt={item.question}
                sx={{
                  width: "38px",
                  height: "38px",
                  marginBottom: "16px",
                }}
              />
              <CardContent style={{ textAlign: "left", padding: 0 }}>
                <Typography
                  variant="h6"
                  sx={{
                    marginBottom: "8px",
                    fontSize: "16px",
                    color: "#53686A",
                  }}
                >
                  {item.question}
                </Typography>
                <Typography
                  variant="body2"
                  color="textSecondary"
                  sx={{ fontSize: "12px", color: "#53686A" }}
                >
                  {renderAnswer(item.answer)}
                </Typography>
                {item.note && (
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    sx={{
                      fontSize: "12px",
                      color: "#53686A",
                      marginTop: "10px",
                    }}
                  >
                    {item.note}
                  </Typography>
                )}
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ContentSection;
